import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { CHEVRON_POINTS, CHEVRON_SIZE, CHEVRON_STROKE_WIDTH, TEST_ID } from './constants';
import { renderGlyphForKind } from './icons';
import type { FunctionComponent, Props, ResultRowKind } from './types';

import styles from './styles.module.scss';

const TILE_KIND_CLASS: Record<ResultRowKind, string> = {
    airport: styles.iconTileAirport,
    place: '',
    recent: ''
};

const ResultRow: FunctionComponent<Props> = ({
    className = '',
    kind,
    onClick,
    primary,
    secondary,
    testId = TEST_ID
}) => (
    <button
        className={`${styles.resultRow} ${className}`}
        data-testid={testId}
        onClick={onClick}
        type='button'>
        <Wrapper
            className={`${styles.iconTile} ${TILE_KIND_CLASS[kind]}`}
            testId={`${testId}-iconTile`}>
            {renderGlyphForKind(kind)}
        </Wrapper>

        <VerticalContainer className={styles.textColumn}>
            <Wrapper className={styles.primary} testId={`${testId}-primary`}>
                {primary}
            </Wrapper>

            <Wrapper className={styles.secondary} testId={`${testId}-secondary`}>
                {secondary}
            </Wrapper>
        </VerticalContainer>

        <svg
            aria-hidden='true'
            className={styles.chevron}
            fill='none'
            height={CHEVRON_SIZE}
            viewBox={`0 0 ${CHEVRON_SIZE} ${CHEVRON_SIZE}`}
            width={CHEVRON_SIZE}
            xmlns='http://www.w3.org/2000/svg'>
            <polyline
                points={CHEVRON_POINTS}
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={CHEVRON_STROKE_WIDTH}
            />
        </svg>
    </button>
);

export default ResultRow;
